const OP = '(?:spec|df|desc|claims|cf)';

const PATTERNS = {
  strict: /^['"][\s\S]*['"]$/,
  spec: /(?:^|\s)spec=\(/,
  decodedFlavors: /(?:^|\s)df=\(/,
  description: /(?:^|\s)desc=\(/,
  flavorClaims: /(?:^|\s)claims=\(/,
  chemicalFormula: /(?:^|\s)cf=\(/,
  claims: /(?:^|\s)claims=\(/,
  operator: new RegExp(`(?:^|\\s)${OP}=\\(([\\s\\S]*?)\\)(?=\\s+${OP}=\\(|\\s*$)`),
};

const WRAPPED = /^"[\s\S]*"$/;

function unwrapStrict(value) {
  if (!WRAPPED.test(value)) return null;
  const inner = value.slice(1, -1);
  return inner.includes('"') ? value.replace(/"/g, '') : inner;
}

function extractBaseSearch(normalized, rawFallback) {
  if (!normalized) return rawFallback;

  const operatorMatch = normalized.match(PATTERNS.operator);
  if (operatorMatch) {
    const inner = operatorMatch[1];
    return unwrapStrict(inner) ?? inner;
  }

  return unwrapStrict(normalized) ?? rawFallback;
}

export function parseSearchStringState(rawSearchString) {
  const searchString = String((Array.isArray(rawSearchString) ? rawSearchString[0] : rawSearchString) ?? '');
  const normalized = searchString.trim();

  const operatorMatch = normalized.match(PATTERNS.operator);
  const operatorInner = operatorMatch ? operatorMatch[1] : null;

  return {
    searchString,
    parsedSearch: extractBaseSearch(normalized, searchString),
    isStrict:
      operatorInner != null ? WRAPPED.test(operatorInner) : Boolean(normalized && PATTERNS.strict.test(normalized)),
    isSpec: PATTERNS.spec.test(normalized),
    isDecodedFlavors: PATTERNS.decodedFlavors.test(normalized),
    isDescription: PATTERNS.description.test(normalized),
    isFlavorClaims: PATTERNS.flavorClaims.test(normalized),
    isChemicalFormula: PATTERNS.chemicalFormula.test(normalized),
    isClaims: PATTERNS.claims.test(normalized),
  };
}
